// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatientFinderResultSearchResponse } from './patientFinderResultSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientV1PatientV1PatientFinderResultSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': PatientFinderResultSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientV1PatientV1PatientFinderResultSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "PatientFinderResultSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return PatientV1PatientV1PatientFinderResultSearchDefaultResponse.attributeTypeMap;
    }
}
